import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import PremiumIcon from '../../../assets/customSVG/PremiumIcon';
import PricingPlanModal from '../../../modules/accounts/components/PricingPlanModal';

const UpgradeBadge = ({ className, style, iconOnly = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const currentBrand = useSelector((state) => state.app.currentBrand);

  const handleClick = (e) => {
    e.stopPropagation();
    if (currentBrand?.brand_id) {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <Tooltip title="Upgrade your brand to access this feature.">
        <div
          className={`inline-flex items-center gap-1.5 ${
            iconOnly ? 'p-1' : 'px-2 py-1'
          } rounded-full bg-white border-2 border-[#FCD34D] cursor-pointer hover:bg-[#FFFBEB] hover:border-[#FBBF24] transition-all duration-200 group shadow-md ${className}`}
          style={style}
          onClick={handleClick}
        >
          <PremiumIcon
            width={iconOnly ? 16 : 14}
            height={iconOnly ? 16 : 14}
            className="group-hover:scale-110 transition-transform duration-200"
          />
          {!iconOnly && (
            <span className="text-xs font-bold text-[#D97706] uppercase tracking-wider">
              Upgrade
            </span>
          )}
        </div>
      </Tooltip>

      {currentBrand?.brand_id && (
        <PricingPlanModal
          open={isModalOpen}
          setOpen={setIsModalOpen}
          brandId={currentBrand.brand_id}
        />
      )}
    </>
  );
};

export default UpgradeBadge;
